import { CardSvg } from '@/play/cardSvg'

/** Home card art: a ruled page with a looping, thick-and-thin line of blue-black ink. */
export function CursiveCardArt() {
  const loops = 'M52 128 C 70 70, 96 70, 86 116 C 80 140, 112 140, 122 100 C 130 64, 150 70, 146 108 C 142 140, 176 138, 186 102 C 196 66, 218 72, 212 112 C 208 138, 240 140, 262 104'
  return (
    <CardSvg bg="#e6dccb">
      <rect x="18" y="12" width="284" height="176" rx="4" fill="#f7f2e6" />
      {[56, 92, 128, 164].map((y) => <line key={y} x1="18" y1={y} x2="302" y2={y} stroke="#c9dcef" strokeWidth="2" />)}
      <line x1="44" y1="12" x2="44" y2="188" stroke="#f2b8b8" strokeWidth="2" />
      {/* raised ink: a soft shadow under a thick-thin stroke */}
      <path d={loops} stroke="#1d2b36" strokeOpacity="0.18" strokeWidth="7" fill="none" strokeLinecap="round" transform="translate(2 3)" />
      <path d={loops} stroke="#1f3a93" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M86 116 C 80 140, 112 140, 122 100 M146 108 C 142 140, 176 138, 186 102 M212 112 C 208 138, 240 140, 262 104" stroke="#1f3a93" strokeWidth="7" fill="none" strokeLinecap="round" />
    </CardSvg>
  )
}
